import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import CampaigncenterFilterCriteria from './CampaigncenterFilterCriteria'
import CampaigncenterList from './CampaigncenterList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './CampaigncenterAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setCampaigncenterDashboardCampaigncenterList } from '../../store/slice/ManufSlice';

export default function CampaigncenterListView({setShowEdit,setCampaigncenterId}){
    const {filterCriteria} = useSelector((state)=>state.manufslice.campaigncenterDashboard);   

    const [filteredCampaigncenterList, setFilteredCampaigncenterList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { campaigncenterDashboard } = useSelector((state) => state.manufslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (campaigncenterDashboard.campaigncenterList.length>-1){
        setFilteredCampaigncenterList(campaigncenterDashboard.campaigncenterList);
        transformToCardFormat(campaigncenterDashboard.campaigncenterList, setCardList);
      }
    },[campaigncenterDashboard.campaigncenterList])

    useEffect(()=>{
          transformToCardFormat(filteredCampaigncenterList, setCardList);
      },[filteredCampaigncenterList])

    useEffect(()=>{
        if (filterCriteria.title==='' && filterCriteria.campaigndate==='' && filterCriteria.campaigncount==='' ){
            setFilteredCampaigncenterList(campaigncenterDashboard.campaigncenterList);
            transformToCardFormat(campaigncenterDashboard.campaigncenterList, setCardList);

        } else {
            setFilteredCampaigncenterList(
                campaigncenterDashboard.campaigncenterList
                    .filter(campaigncenter=> campaigncenter.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(campaigncenterDashboard.filteredCampaigncenterList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <CampaigncenterList
                    setShowEdit={setShowEdit}
                    setCampaigncenterId = {setCampaigncenterId}
                    tableList={filteredCampaigncenterList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}